import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AtmService } from './atm.service';
import { JobAtmAddEditDialogComponent } from './job-atm-add-edit-dialog/job-atm-add-edit-dialog.component';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

// This component is meant to help complete HOT-2219
// This way all logic can be kept in modern Angular
// and not have to add to AngularJS (legacy) code.
@Component({
    selector: 'nova-atm-button',
    standalone: true,
    imports: [AsyncPipe, MatButtonModule],
    templateUrl: './atm-button.component.html',
    styleUrls: ['./atm-button.component.scss']
})
export class AtmButtonComponent implements OnInit {
    @Input()
    jobId: number;

    isAllowed$: Observable<boolean>;

    constructor(
        private readonly _dialogRef: MatDialog,
        private readonly _atmService: AtmService
    ) {}

    ngOnInit(): void {
        this.isAllowed$ = this._atmService.isUserAuthorized().pipe(map((value) => value.hasPermission));
    }

    openAtmDialog(): void {
        this._dialogRef.open(JobAtmAddEditDialogComponent, {
            disableClose: true,
            panelClass: 'nova__dialog',
            data: {
                jobId: this.jobId
            }
        });
    }
}
